import { Flex } from "@mantine/core";
export const Section = ({ children }) => {
	return (
		<Flex direction={"column"} gap={16}>
			{children}
		</Flex>
	);
};
